import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Request from "../../../utils/Request";
import Config from "../../../utils/config";
import MaterialInput from "../../common/UI/MaterialInput";
import { TabsDetailsWrapper, Text, Heading, ButtonSolid, TableWarpper } from "../../styledConstants";
import { Wrapper } from "./style";
import ErrorMessage from "../../ErrorMessage";
import SuccessMessage from "../../SuccessMessage";
import { formValidation } from "../../../utils/formValidation";
import { currencyFormat, isEmpty } from "../../../utils/common";
import Pagination from "../../common/Pagination";
import IconEdit from "../../../assets/images/IconEdit";
import iconattachment from "../../../assets/images/attachment.png";
import ConfirmationModal from "../../common/UI/ConfirmationModal";
import Loader from "../../common/Loader";
import mcc from "../../../assets/mccTest.csv";
import { CSVLink } from "react-csv"; // ✅ NEW

const statusOptions = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

const categoryOptions = [
  { value: 'High Transacting', label: "High Transacting" },
  { value: 'Medium Transacting', label: "Medium Transacting" },
  { value: 'Low Transacting', label: "Low Transacting" },
];

// Define headers for CSV export
const mccHeaders = [
  { label: "MCC Code", key: "mccCode" },
  { label: "MCC Category", key: "mccCategory" },
  { label: "Description", key: "description" },
  { label: "Cashback Type", key: "cashbackType" },
  { label: "Cashback Rate", key: "cashbackRate" },
  { label: "Org Code", key: "orgCode" },
  { label: "Status", key: "isActive" },
];

export default function Mcc() {
  const [formErrors, setFormErrors] = useState([]);
  const [message, setMessage] = useState({ success: "", error: "" });
  const [optionsFeesRate, setOptionsFeesRate] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const initialMccState = {
  mccCode: "",
  mccCategory: "",
  description: "",
  orgCode: "",
  cashbackRate: "",
  cashbackType: "",
  active: null,
  };
  const itemsPerPage = 10;
  const [mccList, setMccList] = useState([]);
  const [mccRow, setMccRow] = useState(initialMccState);
  const [isEdit, setIsEdit] = useState(false);
  const [fileUpload,setFileUpload] = useState("");
   const[showfileName,setShowFileName] = useState("");
  
  const [showModal, setShowModal] = useState(false);

  const clearMessage = () => {
    setTimeout(() => {
      setFormErrors([]);
      setMessage({ success: "", error: "" });
    }, 3000);
  };

  useEffect(() => {
    fetchFeesRate();
    getMccList();
  }, []);

  const fetchFeesRate = () => {
    const submitSuccess = (res) => {
      if (res.code === "0000") {
        let feeRateArr = [];
        if (res.data) {
          Object.keys(res.data).forEach((item) => {
            feeRateArr.push({
              label: res.data[item],
              value: item,
            });
          });
        }
        setOptionsFeesRate(feeRateArr);
      } else {
        // setMessage({ error: res.msg, success: "" });
      }
    };
    const submitError = (res) => {
      //   setMessage({ error: res.msg, success: "" });
    };

    const api = new Request("", submitSuccess, submitError, false);
    return api.get(`${Config.apis.admin.FEES_RATE}`);
  };

  const getMccList = () => {

    const successHandler = (res) => {
      console.log("mcclist",res,res.data.length);
      if (res && res.data) {
        setMccList(res.data);
      }
    };
    const errorHandler = () => {};
    const api = new Request("", successHandler, errorHandler, false);
    return api.get(`${Config.apis.admin.MCC_CONFIGURATION_LIST}`);
  };

  const totalPages = Math.ceil(mccList.length / itemsPerPage);

  const currentData = mccList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const editMcc = (index) => {
    setMccRow(mccList[index]);
    setIsEdit(true);
  };
  const updateMcc = () => {
    const errors = formValidation(mccRow, ['active','cashbackRate']);
    if (!!errors && Object.keys(errors).length != 0) {
      setFormErrors(errors);
    } else {
      const successHandler = (res) => {
        if (res.code === "0000") {
          setMessage({ success: "Successfully updated", error: "" });
          getMccList();
        } else {
          setMessage({ success: "", error: "Something wrong" });
        }
        clearMessage();
      };
      const errorHandler = () => {};
      const api = new Request("", successHandler, errorHandler, false);

      const payload = {
        uuid: mccRow.uuid,
        mccCashbackRate: mccRow.cashbackRate,
        cashbackType: mccRow.cashbackType,
        isActive: mccRow.active,
      };
      return api.post(`${Config.apis.admin.MCC_DETAIL_UPDATE}`, payload);
    }
  };
  const addMcc = () => {
    const payload = {
      mccCode: mccRow.mccCode?mccRow.mccCode:'',
      mccCategory: mccRow.mccCategory?mccRow.mccCategory:'',
      orgCode:mccRow.orgCode?mccRow.orgCode:'',
      cashbackRate: mccRow.cashbackRate?mccRow.cashbackRate:'',
      cashbackType: mccRow.cashbackType?mccRow.cashbackType:'',
      isActive: (mccRow.active !==undefined)?mccRow.active:'',
      description: mccRow.description?mccRow.description:'',
    };

    const errors = formValidation(payload, ['orgCode']);

    
    if (!!errors && Object.keys(errors).length != 0) {
      setFormErrors(errors);
      clearMessage();
    } else {
      const successHandler = (res) => {
        if (res.code === "0000") {
          setMessage({ success: "Successfully Added", error: "" });
          setMccRow(initialMccState);
          getMccList();
        } else {
          setMessage({ success: "", error: res.msg });
        }
        clearMessage();
      };
      const errorHandler = () => {};
      const api = new Request("", successHandler, errorHandler, false);
      
      return api.post(`${Config.apis.admin.ADD_MCC_DETAIL}`, payload);
    }
  };
  const handleFormDataChange = (event) => {
    const regex = /^[0-9\b]+$/;

    if (event?.target?.name === "mccCode") {
      if (event.target.value === "" || regex.test(event.target.value)) {
        if (event.target.value.length > 4) return;
        setMccRow({
          ...mccRow,
          [event.target.name]: event.target.value,
        });
      }
    } else {
      setMccRow({
        ...mccRow,
        [event.target.name]: event.target.value,
      });
    }
    setFormErrors({ ...formErrors, [event.target.name]: "" });
  };
  const handleSelectChange = (event, name) => {
    setMccRow({
      ...mccRow,
      [name]: event.value,
    });
    setFormErrors({ ...formErrors, [name]: "" });
  };

  const handleFileUpload =(value, name, tempfile)=>{
 
    if (!tempfile || !tempfile.name) {
      setFormErrors({ ...formErrors, [name]: "File Removed" });
      setShowFileName('');
      clearMessage();
      return;
    }
    
    console.log("hellotempfile",tempfile?.name);
    if (name === "userattachment") {

      setFileUpload(tempfile);
      setShowFileName(tempfile.name);
    }

 
  
   
  


  }

  const handleUpload =(event)=>{
    

    setShowModal(true);
  }

  const handleCancel = () => {
    setShowModal(null);
  };


  const handleFormSubmit = () => {
    
       
    const successHandler = (res) => {
       
      if(res.message=="SUCCESS"){
        setMessage({ success: "Successfully uploaded", error: "" });
        getMccList();
        setFileUpload(null);
        setShowFileName('');
          setTimeout(()=>{
          setMessage({ success: "", error: "" });
            setShowModal(false)
          },3000);

      }
      else{
        setMessage({ success: "", error: res?.msg });
        setTimeout(()=>{
          setMessage({ success: "", error: "" });
          setShowModal(false)
        },3000);
      }
      
    };
    const errorHandler = () => {};
    const api = new Request("", successHandler, errorHandler, false);
     
     const payload  = new FormData();
   payload.append("file",fileUpload);
     
     
      return api.post(`${Config.API_BASEPATH_PROD+Config.apis.admin.UPLOAD_MCC_FILE_UPLOAD}`,payload);



     
  };

  return (
    <>
      <TabsDetailsWrapper>
        
          <>
        <div className="mb32">
              <strong className="mr8" style={{color:"#fff"}}>{isEdit?"Edit":"Add"} MCC </strong>
        </div>
        {message.success && (
          <>
                <SuccessMessage successMessage={message.success} /> <br />{" "}
          </>
        )}
        {message.error && <ErrorMessage error={message.error} />}
        <div className="limit-form mcc_form">
          <Wrapper className="flex flex-wrap flex-start">
              {  !isEdit ?<><div className="flex flex-end mb20 col">
                  <MaterialInput
                    name="mccCode"
                    onChange={handleFormDataChange}
                    value={mccRow.mccCode}
                    type="text"
                    placeholder="Mcc Code"
                    readonly={isEdit?true:false}
                    error={formErrors?.mccCode}
                  />
                </div>
                <div className="flex flex-center flex-col">
                  <MaterialInput
                    name="mccCategory"
                    onChange={(selectedValue) => handleSelectChange(selectedValue, "mccCategory")}
                    value={categoryOptions.filter((option) => option.value == mccRow.mccCategory)}
                    options={categoryOptions}
                    type="select"
                    placeholder="Category"
                    error={formErrors?.mccCategory}
                  />
                </div>
                <div className="flex flex-end mb20 col">
                  <MaterialInput
                    name="description"
                    onChange={handleFormDataChange}
                    value={mccRow.description}
                    type="text"
                    placeholder="Description"
                    readonly={isEdit?true:false}
                    error={formErrors?.description}
                   
                  />
                </div>
                <div className="flex flex-end mb20 col">
                  <MaterialInput
                    name="orgCode"
                    onChange={handleFormDataChange}
                    value={mccRow.orgCode}
                    type="text"
                    placeholder="Org Code"
                      readonly={isEdit ? true : false}
                    error={formErrors?.orgCode}
                  />
                </div>
              </>
                :''}
               
            <div className="flex flex-end mb20 col">
              <MaterialInput
                name="cashbackType"
                onChange={(selectedValue) => handleSelectChange(selectedValue, "cashbackType")}
                value={optionsFeesRate.filter((option) => option.value === mccRow.cashbackType)}
                options={optionsFeesRate}
                type="select"
                placeholder="Type"
                error={formErrors?.cashbackType}
              />
            </div>

            <div className="flex flex-end mb20 col">
              <MaterialInput
                name="cashbackRate"
                onChange={handleFormDataChange}
                value={mccRow.cashbackRate}
                type="number"
                placeholder="Rate"
                error={formErrors?.cashbackRate}
              />
            </div>
            <div className="flex flex-center flex-col">
              <MaterialInput
                name="active"
                onChange={(selectedValue) => handleSelectChange(selectedValue, "active")}
                    value={statusOptions.filter((option) => option.value == mccRow.active)}
                options={statusOptions}
                type="select"
                placeholder="Status"
                error={formErrors?.isActive}
              />
            </div>

               
               
          </Wrapper>

          <div className="flex gap50">


              {isEdit?<ButtonSolid width="150px" type="button" primary xl className="col" onClick={() => updateMcc()}>
                Update
              </ButtonSolid>:<ButtonSolid width="150px" type="button" primary xl className="col" onClick={() => addMcc()}>
                Add
              </ButtonSolid>}

              
              <ButtonSolid width="150px" type="button" primary xl className="col" onClick={() => handleUpload()}>
              Upload Files
            </ButtonSolid>

            {/* ✅ FIXED CSV DOWNLOAD */}
            <CSVLink
              headers={mccHeaders}
              data={mccList}   // use currentData if only paginated rows needed
              filename="mcc.csv"
            >
              <ButtonSolid width="150px" type="button" primary xl className="col">
                Download CSV
              </ButtonSolid>
            </CSVLink>

            <div className="flex flex-center mb20 mr20 upload-input" style={{ marginLeft: "10px" }}>
              <ButtonSolid className="flex flex-center" lg primary>
           <a href={mcc} download = "mccText.csv">
                  <Text as="span" color="color6">
                    Download sample File
                  </Text>
                </a>
             {/* <CSVLink data={csvData} filename="virtualinventory.xlsx" className="flex">                 
               
             </CSVLink> */}
              </ButtonSolid>
            </div>

          </div>
              

              
        </div>
          </>
        
      </TabsDetailsWrapper>
      {!isEmpty(mccList) ? (
        <TabsDetailsWrapper className="mt32 paymet-settings-log">
          <Heading color="color15" as="h2" className="mb20" size="md">
            Mcc List
          </Heading>
          <TableWarpper>
            <table className="table">
              <thead>
                <tr>
                  <th className="text-left">Mcc Code</th>
                  <th className="text-left">Mcc Category</th>
                  <th className="text-left">Description</th>
                  <th className="text-left">Cashback Type</th>
                  <th className="text-left">Cashback Rate</th>
                  <th className="text-left">Org Code</th>
                  <th className="text-left">Status</th>
                  <th className="text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((mcc, i) => (
                  <tr key={i}>
                    <td>{mcc.mccCode}</td>
                    <td>{mcc.mccCategory}</td>
                    <td>{mcc.description}</td>
                    <td>{mcc.cashbackType}</td>
                    <td>{mcc.cashbackRate}</td>
                    <td>{mcc.orgCode|| "—"}</td>
                    <td><Text size="xsm" fw="medium" color={mcc.isActive ? "color10" : "color11"}>
                        {mcc.isActive? "Active" : "Inactive"}
                      </Text>
                    </td>
                    <td>
                    <Text size="xsm" color="color10" >
                        <Link
                          to="#"
                          onClick={() => {
                            editMcc(i);
                          }}
                        >
                          <IconEdit className="align-top" />
                        </Link>
                      </Text>
                      
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mt24 flex flex-center">
              {totalPages > 1 && (
                <Pagination
                  totalPages={totalPages}
                  currentPage={currentPage}
                  getCurrentPageData={(curpage) => {
                    setCurrentPage(curpage);
                  }}
                />
              )}
            </div>
          </TableWarpper>
        </TabsDetailsWrapper>
      ) : (
        !message.error && <div className="table-loader-wrapper animatedBackground mt24"></div>
      )}

     
{showModal && <ConfirmationModal
          onCancel={handleCancel}
          onConfirm={handleFormSubmit}
          inputComponent={
            <>
        

              <div>

                {message.success && (
                  <>
                <SuccessMessage successMessage={message.success} /> <br />{" "}
              
            
                  </>

                )}
                {message.error && <ErrorMessage error={message.error} />}
                <MaterialInput
                  icon={
                    <span className="icon-attachment flex  flex-center" style={{maxWidth:"20px"}}>
                      <img style={{width:"100%"}} src={iconattachment} alt="alt" />
                    </span>
                  }
                  accept=".csv"
                  name="userattachment"
                  onChange={handleFileUpload}
                  value={showfileName}
                  type="file"
                  placeholder="User Attachment"
                  error={formErrors.userattachment}
                  uploadUrl="/user-service/upload/file"
                 
                />
              </div>
      
            </>
     
     
          }
      >
      </ConfirmationModal>}
    </>
  );
}
